import { createSelector } from 'reselect';

const getTelehealthState = state => state.telehealth;

export const getTelehealthCards = createSelector(
  getTelehealthState,
  telehealth => telehealth.telehealthConfiguration,
);

export const selectTelehealthConfiguration = createSelector(
  getTelehealthState,
  telehealth => telehealth.telehealthConfiguration,
);

export const selectTelehealthConfigurationIsDefault = createSelector(
  getTelehealthState,
  telehealth => telehealth.isDefault,
);

export const selectTelehealthConfigurationIsFetching = createSelector(
  getTelehealthState,
  telehealth => telehealth.isFetching,
);

export const selectTelehealthConfigurationError = createSelector(
  getTelehealthState,
  telehealth => telehealth.error,
);

export const selectTelehealthConfigurationHasFetched = createSelector(
  getTelehealthState,
  telehealth => telehealth.hasFetched,
);
